<div class="container">
    <div class="loader"></div>
</div>